import { useEffect, useState } from "react";
import { useValue } from "../../../../providers/ValueContext";
import { useSausage } from "../../../../providers/SausageContext";
import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import SubHeaderPcp from "../../../../Components/ComponentsIndustry/SubHeaderPcp";
import SalesPredctionCard from "../../../../Components/ComponentsIndustry/SalesPredctionCard";
import InputCardPcp from "../../../../Components/ComponentsIndustry/InputCardPcp";
import axios from "axios";

import { Container, SizeContainer, ContainerInput } from "./style";
import { useUser } from "../../../../providers/UserContext";
import { useMachinery } from "../../../../providers/MachineryContext";

const ToolsPcpSausage = () => {
  const { lossesPercentagem, setLossesPercentagem } = useValue();
  const { user, rodada, industry } = useUser()
  const { infoSausage, setInfoSausage, insumosSausage, getSausageStock } = useSausage();
  const { maquinaSalsichao } = useMachinery()

  let [sausagePrevSales, setSausagePrevSales] = useState(0);
  let [sausageStock, setSausageStock] = useState(0);
  let [costUnit, setCostUnit] = useState(0);
  let [sausagePrevProductions, setSausagePrevProductions] = useState(0);
  let [sausageProductRecipe, setSausageProductRecipe] = useState(0);
  let [priceUnit, setPriceUnit] = useState(0);

  function handlePcp() {

    const data = {
      "custoUnitario": costUnit,
      "industria": {
        industria: industry.industria
      },
      "planejamentoProducao": sausageProductRecipe,
      "previsaoPerda": lossesPercentagem,
      "previsaoProducao": sausagePrevProductions,
      "previsaoVenda": parseFloat(sausagePrevSales).toFixed(2),
      "produto": {
        "produto": 7,
      },
      "rodada": rodada,
      "usuario": user
    }

    axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/cadastrar", data)
      .then(response => fetchPcp())
      .catch(error => console.log("error pcp", error))

  }

  useEffect(() => {

    setSausageStock(
      infoSausage.estoque
    );

    setCostUnit(
      infoSausage.custoUnitario
    );

    setPriceUnit(
      infoSausage.preco
    );

    setSausagePrevProductions(
      parseFloat((sausagePrevSales - sausageStock) * ((100 - lossesPercentagem) / 100) < 0 ? 0 : Math.round((sausagePrevSales - sausageStock) * ((100 - lossesPercentagem) / 100))).toFixed(2)
    );

    setSausageProductRecipe(
      parseFloat(sausagePrevSales * priceUnit?.toFixed(2))
    );

  }, [
    setInfoSausage,
    setSausagePrevProductions,
    lossesPercentagem,
    sausagePrevSales,
    sausageStock,
    sausagePrevProductions,
    costUnit,
    sausageProductRecipe,
    user,
    rodada
  ]);

  useEffect(() => {
    if (!industry?.industria) return
    setLossesPercentagem(3 - industry?.funcControleQualidade ?? 0)
  }, [industry])

  const fetchPcp = async () => {
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterPCP/${industry?.industria}/${rodada?.rodada}/7`)
      .then((response) => {
        console.log(response.data)
        if (response.data.previsaoVenda) {
          setSausagePrevSales(response.data.previsaoVenda)
        }
      })
  }

  useEffect(() => {
    if (!rodada?.rodada) return
    fetchPcp()
  }, [rodada, user])

  useEffect(() => {
    getSausageStock()
  }, [])

  return (
    <Container>

      <SizeContainer>
        <HeaderTools
          pathImg="./images/pcp_button.svg"
          title="PCP"
          subTitle="(Planejamento Controle de Produção)"
          style={["selection", "", "", "", ""]}
        />

        {maquinaSalsichao.amount >= 1 ? (
          <>
            <SubHeaderPcp
              style={["selection", "", "", "", ""]}
              product="Linguiça Salsichão"
              unity="Caixa de 1 Kg"
            />
            <ContainerInput>
              {insumosSausage?.map((insumo, key) => {
                let imageURL = null
                if (insumo.insumo.nome === "Frango P") {
                  imageURL = "./images/chicken_p.svg"
                } else if (insumo.insumo.nome === "Caixa (Papelão)") {
                  imageURL = "./images/box.svg"
                } else if (insumo.insumo.nome === "Pernil Suíno") {
                  imageURL = "./images/pig.svg"
                }
                return (
                  <InputCardPcp
                    path={imageURL ?? insumo.insumo.urlImagem}
                    title={insumo.insumo.nome}
                    value={`${insumo.quantidade}`}
                  />
                )
              })}
            </ContainerInput>

            <SalesPredctionCard
              state1={sausageStock}
              setState1={setSausageStock}
              state2={sausagePrevProductions}
              setState2={setSausagePrevProductions}
              state3={sausagePrevSales}
              setState3={setSausagePrevSales}
              state4={costUnit}
              setState4={setCostUnit}
              state5={priceUnit}
              setState5={setPriceUnit}
              total={sausageProductRecipe}
              setTotal={setSausageProductRecipe}
            />

            <FooterButton
              text="Confirmar"
              path="/toolsPcpChicken"
              onHandle={() => handlePcp()}
            />
          </>
        ) : (
          <>
            <SubHeaderPcp
              style={["selection", "", "", "", ""]}
              product="Linguiça Salsichão"
              unity="Caixa de 1 Kg"
            />
            <ContainerInput style={{ color: "white", padding: 20, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div>ADQUIRA O MAQUINÁRIO PARA PRODUZIR ESTE PRODUTO</div>
            </ContainerInput>
          </>
        )}

      </SizeContainer>
    </Container>
  );
};
export default ToolsPcpSausage;
